// extracted by mini-css-extract-plugin
export default {"countdownDiv":"J1DMQPq1i9SK6r4qjwIH","numericDiv":"dyT5Tdwpae8dfcTefzsi","textDiv":"fTCvWytWMM7lnJuwREeD","carTitle":"XtpDS9eJiCUJD6wzyFBH"};